/* global axios */
import ApiClient from './ApiClient';

// «Тикеты» tab (TOPS-213): the user's tickets across chats.
class OperatorTicketsAPI extends ApiClient {
  constructor() {
    super('operator_tickets', { accountScoped: true });
  }

  get(params = {}) {
    return axios.get(this.url, { params });
  }

  addParticipant(id, userId) {
    return axios.post(`${this.url}/${id}/add_participant`, { user_id: userId });
  }

  removeParticipant(id, userId) {
    return axios.delete(`${this.url}/${id}/remove_participant`, {
      params: { user_id: userId },
    });
  }

  addNote(id, content) {
    return axios.post(`${this.url}/${id}/notes`, { content });
  }

  deleteNote(id, noteId) {
    return axios.delete(`${this.url}/${id}/notes/${noteId}`);
  }
}

export default new OperatorTicketsAPI();
